import { FC } from 'react';
import { Accordion, Box } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';

import { Transfer } from '../../../../types';
import TransfersListItem from '../TransfersListItem';

interface TransfersListProps {
  transfers: Transfer[];
}

const TransfersList: FC<TransfersListProps> = ({ transfers }) => (
  <SunshineCard padding="0">
    <SunshineCard.Content padding="space-0" width="full">
      <Box borderRadius="radius-8" overflow="hidden" width="full">
        {/**
         * TODO(SUN-19): Switch to an element of the design system
         */}
        <Accordion allowMultiple>
          {transfers.map((transfer, index) => (
            // We can't really use anything else and we won't mutate the array or change its order
            <TransfersListItem key={index} transfer={transfer} />
          ))}
        </Accordion>
      </Box>
    </SunshineCard.Content>
  </SunshineCard>
);

export default TransfersList;
